import { render, staticRenderFns } from "./IconBoxMod.vue?vue&type=template&id=762d6ef6"
import script from "./IconBoxMod.vue?vue&type=script&lang=js"
export * from "./IconBoxMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports